import React from "react";
import { ReactComponent as Background } from "./images/background.svg";
import { SkewedTextBox } from "../components/SkewedTextBox";

const HomePage = () => {
  return (
    <div className="relative py-12 px-4 min-h-screen overflow-x-hidden flex flex-col items-center justify-center">
      <Background
        className="absolute top-0 left-0 h-full w-full z-[-1] & polygon:fill-primary"
        preserveAspectRatio="xMidYMid slice"
      />
      <h2 className="relative w-[313px] h-[154px]">
        <SkewedTextBox color="primary" variant="h2" component={"span"}>
          Christian
        </SkewedTextBox>
        <SkewedTextBox
          color="secondary"
          variant="h2"
          component={"span"}
          className="absolute left-[154px] top-[72px]"
        >
          Förg
        </SkewedTextBox>
      </h2>
    </div>
  );
};

export default HomePage;
